// Only one renderer request may be active. Aborting fetch does not stop remote
// FFmpeg, so edits replace pending work rather than aborting and starting more.
export function createPreviewQueue({ render, onResult, onError, onBusy }) {
  let revision = 0;
  let pending = null;
  let active = false;
  let timer = null;
  let disposed = false;
  const controller = new AbortController();

  async function drain() {
    if (disposed || active || !pending?.ready) return;
    const job = pending;
    pending = null;
    active = true;
    try {
      const result = await render(job.value, controller.signal);
      if (!disposed && job.revision === revision) onResult(result, job.value);
    } catch (error) {
      if (!disposed && job.revision === revision) onError(error);
    } finally {
      active = false;
      if (!disposed) {
        if (pending?.ready) drain();
        else if (!pending) onBusy(false);
      }
    }
  }

  return {
    schedule(value, delay = 300) {
      if (disposed) return;
      clearTimeout(timer);
      pending = { value, revision: ++revision, ready: delay === 0 };
      onBusy(true);
      if (delay === 0) drain();
      else timer = setTimeout(() => { pending.ready = true; drain(); }, delay);
    },
    invalidate() {
      revision += 1;
      clearTimeout(timer);
      pending = null;
      onBusy(false);
    },
    dispose() {
      disposed = true;
      clearTimeout(timer);
      pending = null;
      controller.abort();
    },
  };
}
